import { ReactElement } from 'react';
import { Popconfirm } from 'antd';
import { FooterContainer, FooterText, LogoutIcon } from './Footer.style';
import useAuth from '../../features/auth/hooks/useAuth';

const Footer = (): ReactElement => {
  const { user, logout } = useAuth();
  const email = user?.email;
  const handleLogout = () => {
    void logout();
  };

  if (email == null) {
    throw new Error('User email is null in Footer component');
  }
  return (
    <FooterContainer>
      <FooterText>{email}</FooterText>
      <Popconfirm title='ログアウトしますか？' onConfirm={handleLogout} okText='Yes' cancelText='No'>
        <LogoutIcon />
      </Popconfirm>
    </FooterContainer>
  );
};

export default Footer;
